"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestPathAuthSuiteService = exports.requestPathAuthSuiteService = exports.requestPathServiceFalsyValues = void 0;
var auth_suite_config_1 = require("@cbsi-cbscom/auth-suite-config");
var storage_service_1 = require("../storage-service");
var required_params_validator_1 = require("../required-params-validator");
var error_response_1 = require("../error-response");
var queryStringPrefix = "?";
var queryParamsSeparator = "&";
exports.requestPathServiceFalsyValues = [undefined, null];
var isTruthyValue = function (value) {
    return exports.requestPathServiceFalsyValues.indexOf(value) === -1;
};
var buildQueryParam = function (request, param) {
    return "".concat(param, "=").concat(request[param]);
};
var getPath = function (pathPrefix, proxy) {
    var config = auth_suite_config_1.configBase.getConfig();
    var host = isTruthyValue(proxy) ? proxy : config.authSuiteUrl;
    return "".concat(host, "/").concat(pathPrefix);
};
var toQueryString = function (request, params) {
    if (params === void 0) { params = []; }
    return params.map(function (param) { return buildQueryParam(request, param); }).join(queryParamsSeparator);
};
var getAuthSuiteRequestParams = function () {
    var authSuiteRequestData = storage_service_1.authSuiteDataLocalStorageService.getAuthSuiteRequestData();
    var isAuthSuiteRequestDataValid = required_params_validator_1.requiredParamsValidator.isValid(authSuiteRequestData);
    var authSuiteRequestParams = toQueryString(authSuiteRequestData, Object.keys(authSuiteRequestData));
    return isAuthSuiteRequestDataValid
        ? Promise.resolve(authSuiteRequestParams)
        : Promise.reject(error_response_1.authSuiteErrorFactory.createError(error_response_1.MethodErrorResponse.MISSING_REQUIRED_PARAMS));
};
var getAdditionalRequestParams = function (request, params) {
    if (params === void 0) { params = []; }
    var validParams = params.filter(function (param) { return isTruthyValue(request[param]); });
    return toQueryString(request, validParams);
};
var getQueryString = function (request, additionalParams) {
    if (additionalParams === void 0) { additionalParams = []; }
    return getAuthSuiteRequestParams().then(function (authSuiteRequiredQueryParams) {
        var params = "".concat(queryStringPrefix).concat(authSuiteRequiredQueryParams);
        var customParams = getAdditionalRequestParams(request, additionalParams);
        return customParams.length ? [params, customParams].join("&") : params;
    });
};
var getFullPath = function (fetchData) {
    var requestPath = getPath(fetchData.path, fetchData.proxy);
    return getQueryString(fetchData.request, fetchData.requestParams).then(function (queryString) { return ({
        path: "".concat(requestPath).concat(queryString),
    }); });
};
exports.requestPathAuthSuiteService = {
    getFullPath: getFullPath,
};
var RequestPathAuthSuiteService = /** @class */ (function () {
    function RequestPathAuthSuiteService() {
        return exports.requestPathAuthSuiteService;
    }
    return RequestPathAuthSuiteService;
}());
exports.RequestPathAuthSuiteService = RequestPathAuthSuiteService;
